export const data3_2_1 = [{
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: '',
    name_code: '',
    money: "0",
    note: ""
}, {
    name: 'Total',
    name_code: 'Total',
    money: "0",
    note: ""
}];

export const data9_2 = [{
    zeroDay: "0",
    threeDay: "0",
    sixDay: "0",
    nineDay: "0",
    overDay: "0",
    totalDay: "0",
    zeroPercent: "0",
    threePercent: "0",
    sixPercent: "0",
    ninePercent: "0",
    overPercent: "0",
    totalPercent: "0",
}]




// WEBPACK FOOTER //
// ./src/components/table/9.0/9-3/data.js